module.exports = __webpack_public_path__ + "static/media/para-empresas.e7dccac6.jpg";